var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_7983",
    "data-name": "\\uADF8\\uB8F9 7983",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12636",
    "data-name": "\\uD328\\uC2A4 12636",
    d: "M404.141,623.565H392.213a4.537,4.537,0,0,1-4.537-4.536V607.1a4.536,4.536,0,0,1,4.537-4.537h11.927a4.536,4.536,0,0,1,4.536,4.537v11.928a4.536,4.536,0,0,1-4.536,4.536",
    transform: "translate(-387.677 -602.564)",
    fill: "#e61f19"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8001",
    "data-name": "\\uADF8\\uB8F9 8001",
    transform: "translate(4.046 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12637",
    "data-name": "\\uD328\\uC2A4 12637",
    d: "M422.537,637.935a1.747,1.747,0,0,0-1.229-1.237,50.6,50.6,0,0,0-10.863,0,1.746,1.746,0,0,0-1.229,1.237,19.663,19.663,0,0,0,0,6.736,1.747,1.747,0,0,0,1.229,1.237,50.582,50.582,0,0,0,10.863,0,1.747,1.747,0,0,0,1.229-1.237,19.665,19.665,0,0,0,0-6.736",
    transform: "translate(-408.925 -636.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12638",
    "data-name": "\\uD328\\uC2A4 12638",
    d: "M437.676,655.4l3.634-2.067-3.634-2.067Z",
    transform: "translate(-432.202 -648.438)",
    fill: "#e61f19"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b79fbc3bd20ba33c57214c58f8e0a4f8.svg";
export { ForwardRef as ReactComponent };